module.exports = __webpack_public_path__ + "img/modal_bg.0b7770f4.png";